'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagentBinaryParser = require('./superagent-binary-parser');

var _superagentBinaryParser2 = _interopRequireDefault(_superagentBinaryParser);

var _Defaults = require('./Defaults');

var _Defaults2 = _interopRequireDefault(_Defaults);

var _EventStream = require('./EventStream');

var _EventStream2 = _interopRequireDefault(_EventStream);

var _Agent = require('./Agent');

var _Agent2 = _interopRequireDefault(_Agent);

var _Client = require('./Client');

var _Client2 = _interopRequireDefault(_Client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Particle Cloud API wrapper.
 *
 * See <https://docs.particle.io/reference/javascript/> for examples
 * of using the `Particle` class.
 *
 * Most Particle methods take a single unnamed argument object documented as
 * `options` with key/value pairs for each option.
 */
var Particle = function () {
	/**
  * Contructor for the Cloud API wrapper.
  *
  * Create a new Particle object and call methods below on it.
  *
  * @param  {Object} options Options for this API call Options to be used for all requests (see [Defaults](../src/Defaults.js))
  */
	function Particle() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		(0, _classCallCheck3.default)(this, Particle);

		if (options.auth) {
			this.setDefaultAuth(options.auth);
		}

		// todo - this seems a bit dangerous - would be better to put all options/context in a contained object
		(0, _assign2.default)(this, _Defaults2.default, options);
		this.context = {};
		this.agent = new _Agent2.default(this.baseUrl);
	}

	(0, _createClass3.default)(Particle, [{
		key: '_isValidContext',
		value: function _isValidContext(name, context) {
			return (name === 'tool' || name === 'project') && context !== undefined;
		}
	}, {
		key: 'setContext',
		value: function setContext(name, context) {
			if (context !== undefined) {
				if (this._isValidContext(name, context)) {
					this.context[name] = context;
				} else {
					throw Error('unknown context name or undefined context: ' + name);
				}
			}
		}

		/**
   * Builds the final context from the context parameter and the context items in the api.
   * @param  {Object} context       The invocation context, this takes precedence over the local context.
   * @returns {Object} The context to use.
   * @private
   */

	}, {
		key: '_buildContext',
		value: function _buildContext(context) {
			return (0, _assign2.default)(this.context, context);
		}

		/**
   * Login to Particle Cloud using an existing Particle acccount.
   * @param  {Object} options                Options for this API call
   * @param  {String} options.username       Username for the Particle account
   * @param  {String} options.password       Password for the Particle account
   * @param  {Number} options.tokenDuration  How long the access token should last in seconds
   * @param  {Object} [options.headers]      Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param  {Number} [options.context]      Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'login',
		value: function login(_ref) {
			var username = _ref.username,
			    password = _ref.password,
			    _ref$tokenDuration = _ref.tokenDuration,
			    tokenDuration = _ref$tokenDuration === undefined ? this.tokenDuration : _ref$tokenDuration,
			    headers = _ref.headers,
			    context = _ref.context;

			return this.request({
				uri: '/oauth/token',
				method: 'post',
				headers: headers,
				form: {
					username: username,
					password: password,
					grant_type: 'password',
					client_id: this.clientId,
					client_secret: this.clientSecret,
					expires_in: tokenDuration
				},
				context: context
			});
		}

		/**
   * If login failed with an 'mfa_required' error, this must be called with a valid OTP code to login
   * @param  {Object} options            Options for this API call
   * @param  {String} options.mfaToken   Given as 'mfa_token' in the error body of `.login()`.
   * @param  {String} options.otp        Current one-time-password generated from the authentication application
   * @param  {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param  {Number} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'sendOtp',
		value: function sendOtp(_ref2) {
			var mfaToken = _ref2.mfaToken,
			    otp = _ref2.otp,
			    headers = _ref2.headers,
			    context = _ref2.context;

			return this.request({
				uri: '/oauth/token',
				method: 'post',
				headers: headers,
				form: {
					grant_type: 'urn:custom:mfa-otp',
					mfa_token: mfaToken,
					otp: otp,
					client_id: this.clientId,
					client_secret: this.clientSecret
				},
				context: context
			});
		}

		/**
   * Enable MFA on the currently logged in user
   * @param {Object} options             Options for this API call
   * @param {Object} options.auth        Access token
   * @param  {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]   Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'enableMfa',
		value: function enableMfa(_ref3) {
			var auth = _ref3.auth,
			    headers = _ref3.headers,
			    context = _ref3.context;

			return this.get({ uri: '/v1/user/mfa-enable', auth: auth, headers: headers, context: context });
		}

		/**
   * Confirm MFA for the user. This must be called with current TOTP code, determined from the results of enableMfa(). You will be prompted to enter an OTP code every time you login after enrollment is confirmed.
   * @param {Object} options            Options for this API call
   * @param {Object} options.auth       Access token
   * @param {Object} options.mfaToken   Token given from previous step to
   * @param {Object} options.otp        Current one-time-password generated from the authentication app
   * @param {Boolean} options.invalidateTokens Should all tokens be invalidated
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'confirmMfa',
		value: function confirmMfa(_ref4) {
			var mfaToken = _ref4.mfaToken,
			    otp = _ref4.otp,
			    _ref4$invalidateToken = _ref4.invalidateTokens,
			    invalidateTokens = _ref4$invalidateToken === undefined ? false : _ref4$invalidateToken,
			    auth = _ref4.auth,
			    headers = _ref4.headers,
			    context = _ref4.context;

			var data = { mfa_token: mfaToken, otp: otp };

			if (invalidateTokens) {
				data.invalidate_tokens = true;
			}

			return this.post({
				uri: '/v1/user/mfa-enable',
				auth: auth,
				headers: headers,
				data: data,
				context: context
			});
		}

		/**
   * Disable MFA for the user.
   * @param {Object} options                  Options for this API call
   * @param {Object} options.auth             Access token
   * @param {Object} options.currentPassword  User's current password
   * @param {Object} [options.headers]        Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]        Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'disableMfa',
		value: function disableMfa(_ref5) {
			var currentPassword = _ref5.currentPassword,
			    auth = _ref5.auth,
			    headers = _ref5.headers,
			    context = _ref5.context;

			return this.put({
				uri: '/v1/user/mfa-disable',
				auth: auth,
				headers: headers,
				data: { current_password: currentPassword },
				context: context
			});
		}

		/**
   * Create Customer for Product.
   * @param {Object} options            Options for this API call
   * @param {String} options.email      Username for the Particle account
   * @param {String} options.password   Password for the Particle account
   * @param {String} options.product    Create the customer in this product ID or slug
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'createCustomer',
		value: function createCustomer(_ref6) {
			var email = _ref6.email,
			    password = _ref6.password,
			    product = _ref6.product,
			    headers = _ref6.headers,
			    context = _ref6.context;

			return this.request({
				uri: '/v1/products/' + product + '/customers',
				method: 'post',
				headers: headers,
				form: {
					email: email,
					password: password,
					grant_type: 'client_credentials',
					client_id: this.clientId,
					client_secret: this.clientSecret
				},
				context: context
			});
		}

		/**
   * Login to Particle Cloud using an OAuth client.
   * @param {Object} options            Options for this API call
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'loginAsClientOwner',
		value: function loginAsClientOwner(_ref7) {
			var headers = _ref7.headers,
			    context = _ref7.context;

			return this.request({
				uri: '/oauth/token',
				method: 'post',
				headers: headers,
				form: {
					grant_type: 'client_credentials',
					client_id: this.clientId,
					client_secret: this.clientSecret
				},
				context: context
			});
		}

		/**
   * Create a user account for the Particle Cloud
   * @param {Object} options              Options for this API call
   * @param {String} options.username     Email of the new user
   * @param {String} options.password     Password
   * @param {String} options.accountInfo  Object that contains account information fields such as user real name, company name, business account flag etc
   * @param {Object} [options.headers]    Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]    Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'createUser',
		value: function createUser(_ref8) {
			var username = _ref8.username,
			    password = _ref8.password,
			    accountInfo = _ref8.accountInfo,
			    headers = _ref8.headers,
			    context = _ref8.context;

			return this.post({
				uri: '/v1/users',
				headers: headers,
				data: {
					username: username,
					password: password,
					account_info: accountInfo
				},
				context: context
			});
		}

		/**
   * Verify new user account via verification email
   * @param {Object} options            Options for this API call
   * @param {String} options.token      The string token sent in the verification email
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'verifyUser',
		value: function verifyUser(_ref9) {
			var token = _ref9.token,
			    headers = _ref9.headers,
			    context = _ref9.context;

			return this.post({
				uri: '/v1/user/verify',
				headers: headers,
				data: { token: token },
				context: context
			});
		}

		/**
   * Send reset password email for a Particle Cloud user account
   * @param {Object} options            Options for this API call
   * @param {String} options.username   Email of the user
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'resetPassword',
		value: function resetPassword(_ref10) {
			var username = _ref10.username,
			    headers = _ref10.headers,
			    context = _ref10.context;

			return this.post({
				uri: '/v1/user/password-reset',
				headers: headers,
				data: { username: username },
				context: context
			});
		}

		/**
   * Revoke an access token
   * @param {Object} options            Options for this API call
   * @param {String} options.username   Username of the Particle cloud account that the token belongs to.
   * @param {String} options.password   Password for the account
   * @param {String} options.token      Access token you wish to revoke
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteAccessToken',
		value: function deleteAccessToken(_ref11) {
			var username = _ref11.username,
			    password = _ref11.password,
			    token = _ref11.token,
			    headers = _ref11.headers,
			    context = _ref11.context;

			return this.delete({
				uri: '/v1/access_tokens/' + token,
				auth: { username: username, password: password },
				headers: headers,
				data: { access_token: token },
				context: context
			});
		}

		/**
   * Revoke the current session access token
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteCurrentAccessToken',
		value: function deleteCurrentAccessToken(_ref12) {
			var auth = _ref12.auth,
			    headers = _ref12.headers,
			    context = _ref12.context;

			return this.delete({
				uri: '/v1/access_tokens/current',
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Revoke all active access tokens
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteActiveAccessTokens',
		value: function deleteActiveAccessTokens(_ref13) {
			var auth = _ref13.auth,
			    headers = _ref13.headers,
			    context = _ref13.context;

			return this.delete({
				uri: '/v1/access_tokens',
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Delete the current user
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       Access Token
   * @param {String} options.password   Password
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteUser',
		value: function deleteUser(_ref14) {
			var auth = _ref14.auth,
			    password = _ref14.password,
			    headers = _ref14.headers,
			    context = _ref14.context;

			return this.delete({
				uri: '/v1/user',
				data: { password: password },
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * List all valid access tokens for a Particle Cloud account
   * @param {Object} options            Options for this API call
   * @param {String} options.username   Username
   * @param {String} options.password   Password
   * @param {String} options.otp        Current one-time-password generated from the authentication application
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listAccessTokens',
		value: function listAccessTokens(_ref15) {
			var username = _ref15.username,
			    password = _ref15.password,
			    otp = _ref15.otp,
			    headers = _ref15.headers,
			    context = _ref15.context;

			return this.get({
				uri: '/v1/access_tokens',
				auth: { username: username, password: password },
				query: otp ? { otp: otp } : undefined,
				headers: headers,
				context: context
			});
		}

		/**
   * Retrieves the information that is used to identify the current login for tracking.
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       The access token
   * @param {Boolean} options.full      When true, retrieve all information for registering a user with the tracking API. When false,
   *                                    retrieve only the unique tracking ID for the current login.
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} Resolve the tracking identify of the current login
   */

	}, {
		key: 'trackingIdentity',
		value: function trackingIdentity() {
			var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
			    _ref16$full = _ref16.full,
			    full = _ref16$full === undefined ? false : _ref16$full,
			    auth = _ref16.auth,
			    headers = _ref16.headers,
			    context = _ref16.context;

			return this.get({
				uri: '/v1/user/identify',
				auth: auth,
				headers: headers,
				query: full ? undefined : { tracking: 1 },
				context: context
			});
		}

		/**
   * List devices claimed to the account or product
   * @param {Object} options                   Options for this API call
   * @param {String} [options.deviceId]        (Product only) Filter results to devices with this ID (partial matching)
   * @param {String} [options.deviceName]      (Product only) Filter results to devices with this name (partial matching)
   * @param {Array.<string>} [options.groups]  (Product only) A list of full group names to filter results to devices belonging to these groups only.
   * @param {String} [options.sortAttr]        (Product only) The attribute by which to sort results. See API docs for options.
   * @param {String} [options.sortDir]         (Product only) The direction of sorting. See API docs for options.
   * @param {Number} [options.page]            (Product only) Current page of results
   * @param {Number} [options.perPage]         (Product only) Records per page
   * @param {String} [options.product]         List devices in this product ID or slug
   * @param {String} options.auth              Access Token
   * @param {Object} [options.headers]         Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]         Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listDevices',
		value: function listDevices(_ref17) {
			var deviceId = _ref17.deviceId,
			    deviceName = _ref17.deviceName,
			    groups = _ref17.groups,
			    sortAttr = _ref17.sortAttr,
			    sortDir = _ref17.sortDir,
			    page = _ref17.page,
			    perPage = _ref17.perPage,
			    product = _ref17.product,
			    auth = _ref17.auth,
			    headers = _ref17.headers,
			    context = _ref17.context;

			var uri = void 0,
			    query = void 0;

			if (product) {
				uri = '/v1/products/' + product + '/devices';
				groups = Array.isArray(groups) ? groups.join(',') : undefined;
				query = { deviceId: deviceId, deviceName: deviceName, groups: groups, sortAttr: sortAttr, sortDir: sortDir, page: page, per_page: perPage };
			} else {
				uri = '/v1/devices';
			}

			return this.get({ uri: uri, auth: auth, headers: headers, query: query, context: context });
		}

		/**
   * Get detailed informationa about a device
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} [options.product]  Device in this product ID or slug
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getDevice',
		value: function getDevice(_ref18) {
			var deviceId = _ref18.deviceId,
			    product = _ref18.product,
			    auth = _ref18.auth,
			    headers = _ref18.headers,
			    context = _ref18.context;

			var uri = this.deviceUri({ deviceId: deviceId, product: product });
			return this.get({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Claim a device to the account. The device must be online and unclaimed.
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'claimDevice',
		value: function claimDevice(_ref19) {
			var deviceId = _ref19.deviceId,
			    requestTransfer = _ref19.requestTransfer,
			    auth = _ref19.auth,
			    headers = _ref19.headers,
			    context = _ref19.context;

			return this.post({
				uri: '/v1/devices',
				auth: auth,
				headers: headers,
				data: {
					id: deviceId,
					request_transfer: !!requestTransfer
				},
				context: context
			});
		}

		/**
   * Add a device to a product or move device out of quarantine.
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID
   * @param {Object} options.file       A file that contains a single-column list of device IDs, device serial numbers, device IMEIs, or devie ICCIDs.
   *                                    Node: Either a path or Buffer. Browser: a File or Blob.
   * @param {String} options.product    Add to this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'addDeviceToProduct',
		value: function addDeviceToProduct(_ref20) {
			var deviceId = _ref20.deviceId,
			    product = _ref20.product,
			    file = _ref20.file,
			    auth = _ref20.auth,
			    headers = _ref20.headers,
			    context = _ref20.context;

			var files = void 0,
			    data = void 0;

			if (file) {
				files = { file: file };
			} else if (deviceId) {
				data = { id: deviceId };
			}

			return this.request({
				uri: '/v1/products/' + product + '/devices',
				method: 'post',
				headers: headers,
				data: data,
				files: files,
				auth: auth,
				context: context
			});
		}

		/**
   * Unclaim / Remove a device from your account or product, or deny quarantine
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {Boolean} [options.deny]    (Product only) Deny this quarantined device, instead of removing an already approved device
   * @param {String} options.product    Remove from this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'removeDevice',
		value: function removeDevice(_ref21) {
			var deviceId = _ref21.deviceId,
			    deny = _ref21.deny,
			    product = _ref21.product,
			    auth = _ref21.auth,
			    headers = _ref21.headers,
			    context = _ref21.context;

			var uri = this.deviceUri({ deviceId: deviceId, product: product });
			var data = product ? { deny: deny } : undefined;
			return this.delete({ uri: uri, data: data, auth: auth, headers: headers, context: context });
		}

		/**
   * Unclaim a product device its the owner, but keep it in the product
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.product    Remove from this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'removeDeviceOwner',
		value: function removeDeviceOwner(_ref22) {
			var deviceId = _ref22.deviceId,
			    product = _ref22.product,
			    auth = _ref22.auth,
			    headers = _ref22.headers,
			    context = _ref22.context;

			var uri = '/v1/products/' + product + '/devices/' + deviceId + '/owner';
			return this.delete({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Rename a device
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.name       Desired Name
   * @param {String} [options.product]  Rename device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'renameDevice',
		value: function renameDevice(_ref23) {
			var deviceId = _ref23.deviceId,
			    name = _ref23.name,
			    product = _ref23.product,
			    auth = _ref23.auth,
			    headers = _ref23.headers,
			    context = _ref23.context;

			return this.updateDevice({ deviceId: deviceId, name: name, product: product, auth: auth, headers: headers, context: context });
		}

		/**
   * Instruct the device to turn on/off the LED in a rainbow pattern
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {Boolean} options.signal    Signal on or off
   * @param {String} [options.product]  Device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'signalDevice',
		value: function signalDevice(_ref24) {
			var deviceId = _ref24.deviceId,
			    signal = _ref24.signal,
			    product = _ref24.product,
			    auth = _ref24.auth,
			    headers = _ref24.headers,
			    context = _ref24.context;

			return this.updateDevice({ deviceId: deviceId, signal: signal, product: product, auth: auth, headers: headers, context: context });
		}

		/**
   * Store some notes about device
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.notes      Your notes about this device
   * @param {String} [options.product]  Device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'setDeviceNotes',
		value: function setDeviceNotes(_ref25) {
			var deviceId = _ref25.deviceId,
			    notes = _ref25.notes,
			    product = _ref25.product,
			    auth = _ref25.auth,
			    headers = _ref25.headers,
			    context = _ref25.context;

			return this.updateDevice({ deviceId: deviceId, notes: notes, product: product, auth: auth, headers: headers, context: context });
		}

		/**
   * Mark device as being used in development of a product so it opts out of automatic firmware updates
   * @param {Object} options               Options for this API call
   * @param {String} options.deviceId      Device ID or Name
   * @param {Boolean} options.development  Set to true to mark as development, false to return to product fleet
   * @param {String} options.product       Device in this product ID or slug
   * @param {String} options.auth          Access Token
   * @param {Object} [options.headers]     Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]     Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'markAsDevelopmentDevice',
		value: function markAsDevelopmentDevice(_ref26) {
			var deviceId = _ref26.deviceId,
			    _ref26$development = _ref26.development,
			    development = _ref26$development === undefined ? true : _ref26$development,
			    product = _ref26.product,
			    auth = _ref26.auth,
			    headers = _ref26.headers,
			    context = _ref26.context;

			return this.updateDevice({ deviceId: deviceId, development: development, product: product, auth: auth, headers: headers, context: context });
		}

		/**
   * Mark device as being used in development of a product so it opts out of automatic firmware updates
   * @param {Object} options                         Options for this API call
   * @param {String} options.deviceId                Device ID or Name
   * @param {Number} options.desiredFirmwareVersion  Lock the product device to run this firmware version.
   * @param {Boolean} [options.flash]                Immediately flash firmware indicated by desiredFirmwareVersion
   * @param {String} options.product                 Device in this product ID or slug
   * @param {String} options.auth                    Access Token
   * @param {Object} [options.headers]               Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]               Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'lockDeviceProductFirmware',
		value: function lockDeviceProductFirmware(_ref27) {
			var deviceId = _ref27.deviceId,
			    desiredFirmwareVersion = _ref27.desiredFirmwareVersion,
			    flash = _ref27.flash,
			    product = _ref27.product,
			    auth = _ref27.auth,
			    context = _ref27.context;

			return this.updateDevice({ deviceId: deviceId, desiredFirmwareVersion: desiredFirmwareVersion, flash: flash, product: product, auth: auth, context: context });
		}

		/**
   * Mark device as receiving automatic firmware updates
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.product    Device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'unlockDeviceProductFirmware',
		value: function unlockDeviceProductFirmware(_ref28) {
			var deviceId = _ref28.deviceId,
			    product = _ref28.product,
			    auth = _ref28.auth,
			    headers = _ref28.headers,
			    context = _ref28.context;

			return this.updateDevice({ deviceId: deviceId, desiredFirmwareVersion: null, product: product, auth: auth, headers: headers, context: context });
		}

		/**
   * Update multiple device attributes at the same time
   * @param {Object} options                           Options for this API call
   * @param {String} options.deviceId                  Device ID or Name
   * @param {String} [options.name]                    Desired Name
   * @param {Boolean} options.signal                   Signal device on or off
   * @param {String} [options.notes]                   Your notes about this device
   * @param {Boolean} [options.development]            (Product only) Set to true to mark as development, false to return to product fleet
   * @param {Number} [options.desiredFirmwareVersion]  (Product only) Lock the product device to run this firmware version.
   *                                                   Pass `null` to unlock firmware and go back to released firmware.
   * @param {Boolean} [options.flash]                  (Product only) Immediately flash firmware indicated by desiredFirmwareVersion
   * @param {String} [options.product]                 Device in this product ID or slug
   * @param {String} options.auth                      Access Token
   * @param {Object} [options.headers]                 Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]                 Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'updateDevice',
		value: function updateDevice(_ref29) {
			var deviceId = _ref29.deviceId,
			    name = _ref29.name,
			    signal = _ref29.signal,
			    notes = _ref29.notes,
			    development = _ref29.development,
			    desiredFirmwareVersion = _ref29.desiredFirmwareVersion,
			    flash = _ref29.flash,
			    product = _ref29.product,
			    auth = _ref29.auth,
			    headers = _ref29.headers,
			    context = _ref29.context;

			if (signal !== undefined) {
				signal = signal ? '1' : '0';
			}

			var uri = this.deviceUri({ deviceId: deviceId, product: product });
			var data = product ? { name: name, signal: signal, notes: notes, development: development, desired_firmware_version: desiredFirmwareVersion, flash: flash } : { name: name, signal: signal, notes: notes };

			return this.put({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Provision a new device for products that allow self-provisioning
   * @param {Object} options            Options for this API call
   * @param {String} options.productId  Product ID where to create this device
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'provisionDevice',
		value: function provisionDevice(_ref30) {
			var productId = _ref30.productId,
			    auth = _ref30.auth,
			    headers = _ref30.headers,
			    context = _ref30.context;

			return this.post({
				uri: '/v1/devices',
				auth: auth,
				headers: headers,
				data: { product_id: productId },
				context: context
			});
		}

		/**
   * Generate a claim code to use in the device claiming process.
   * To generate a claim code for a product, the access token MUST belong to a
   * customer of the product.
   * @param {Object} options            Options for this API call
   * @param {String} [options.iccid]    ICCID of the SIM card used in the Electron
   * @param {String} [options.product]  Device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getClaimCode',
		value: function getClaimCode(_ref31) {
			var iccid = _ref31.iccid,
			    product = _ref31.product,
			    auth = _ref31.auth,
			    headers = _ref31.headers,
			    context = _ref31.context;

			var uri = product ? '/v1/products/' + product + '/device_claims' : '/v1/device_claims';
			return this.post({ uri: uri, auth: auth, headers: headers, data: { iccid: iccid }, context: context });
		}
	}, {
		key: 'validatePromoCode',
		value: function validatePromoCode(_ref32) {
			var promoCode = _ref32.promoCode,
			    auth = _ref32.auth,
			    headers = _ref32.headers,
			    context = _ref32.context;

			return this.get({
				uri: '/v1/promo_code/' + promoCode,
				auth: auth,
				headers: headers,
				context: context
			});
		}
	}, {
		key: 'changeProduct',
		value: function changeProduct(_ref33) {
			var deviceId = _ref33.deviceId,
			    productId = _ref33.productId,
			    auth = _ref33.auth,
			    headers = _ref33.headers,
			    context = _ref33.context;

			return this.put({
				uri: '/v1/devices/' + deviceId,
				auth: auth,
				headers: headers,
				data: { product_id: productId },
				context: context
			});
		}

		/**
   * Get the value of a device variable
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.name       Variable name
   * @param {String} [options.product]  Device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getVariable',
		value: function getVariable(_ref34) {
			var deviceId = _ref34.deviceId,
			    name = _ref34.name,
			    product = _ref34.product,
			    auth = _ref34.auth,
			    headers = _ref34.headers,
			    context = _ref34.context;

			var uri = product ? '/v1/products/' + product + '/devices/' + deviceId + '/' + name : '/v1/devices/' + deviceId + '/' + name;

			return this.get({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Compile and flash application firmware to a device. Pass a pre-compiled binary to flash it directly to the device.
   * @param {Object} options                         Options for this API call
   * @param {String} options.deviceId                Device ID or Name
   * @param {String} options.product                 Flash device in this product ID or slug
   * @param {Object} options.files                   Object containing files to be compiled and flashed. Keys should be the filenames, including relative path, and the values should be a path or Buffer of the file contents in Node, or a File or Blob in the browser.
   * @param {String} [options.targetVersion=latest]  System firmware version to compile against
   * @param {String} options.auth                    Access Token
   * @param {Object} [options.headers]               Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]               Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'flashDevice',
		value: function flashDevice(_ref35) {
			var deviceId = _ref35.deviceId,
			    product = _ref35.product,
			    files = _ref35.files,
			    targetVersion = _ref35.targetVersion,
			    auth = _ref35.auth,
			    headers = _ref35.headers,
			    context = _ref35.context;

			var uri = this.deviceUri({ deviceId: deviceId, product: product });
			var form = {};

			if (targetVersion) {
				form.build_target_version = targetVersion;
			} else {
				form.latest = 'true';
			}

			return this.request({ uri: uri, method: 'put', auth: auth, headers: headers, files: files, form: form, context: context });
		}

		/**
   * DEPRECATED: Flash the Tinker application to a device. Instead compile and flash the Tinker source code.
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'flashTinker',
		value: function flashTinker(_ref36) {
			var deviceId = _ref36.deviceId,
			    auth = _ref36.auth,
			    headers = _ref36.headers,
			    context = _ref36.context;

			/* eslint-disable no-console */
			if (console && console.warning) {
				console.warning('Particle.flashTinker is deprecated');
			}
			/* eslint-enable no-console */
			return this.put({
				uri: '/v1/devices/' + deviceId,
				headers: headers,
				data: { app: 'tinker' },
				auth: auth,
				context: context
			});
		}

		/**
   * Compile firmware using the Particle Cloud
   * @param {Object} options                         Options for this API call
   * @param {Object} options.files                   Object containing files to be compiled. Keys should be the filenames, including relative path, and the values should be a path or Buffer of the file contents in Node, or a File or Blob in the browser.
   * @param {Number} [options.platformId]            Platform id number of the device you are compiling for. Common values are 0=Core, 6=Photon, 10=Electron.
   * @param {String} [options.targetVersion=latest]  System firmware version to compile against
   * @param {String} options.auth                    Access Token
   * @param {Object} [options.headers]               Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]               Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'compileCode',
		value: function compileCode(_ref37) {
			var files = _ref37.files,
			    platformId = _ref37.platformId,
			    targetVersion = _ref37.targetVersion,
			    auth = _ref37.auth,
			    headers = _ref37.headers,
			    context = _ref37.context;

			var form = { platform_id: platformId };

			if (targetVersion) {
				form.build_target_version = targetVersion;
			} else {
				form.latest = 'true';
			}

			return this.request({
				uri: '/v1/binaries',
				method: 'post',
				auth: auth,
				headers: headers,
				files: files,
				form: form,
				context: context
			});
		}

		/**
   * Download a firmware binary
   * @param {Object} options            Options for this API call
   * @param {String} options.binaryId   Binary ID received from a successful compile call
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Request} A promise
   */

	}, {
		key: 'downloadFirmwareBinary',
		value: function downloadFirmwareBinary(_ref38) {
			var binaryId = _ref38.binaryId,
			    auth = _ref38.auth,
			    headers = _ref38.headers,
			    context = _ref38.context;

			var req = this.request({
				uri: '/v1/binaries/' + binaryId,
				method: 'get',
				auth: auth,
				headers: headers,
				context: context,
				raw: true
			});

			return this._provideFileData(req);
		}

		/**
   * Send a new device public key to the Particle Cloud
   * @param {Object} options                  Options for this API call
   * @param {String} options.deviceId         Device ID or Name
   * @param {(String|Buffer)} options.key     Public key contents
   * @param {String} [options.algorithm=rsa]  Algorithm used to generate the public key. Valid values are `rsa` or `ecc`.
   * @param {String} options.auth             Access Token
   * @param {Object} [options.headers]        Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]        Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'sendPublicKey',
		value: function sendPublicKey(_ref39) {
			var deviceId = _ref39.deviceId,
			    key = _ref39.key,
			    algorithm = _ref39.algorithm,
			    auth = _ref39.auth,
			    headers = _ref39.headers,
			    context = _ref39.context;

			return this.post({
				uri: '/v1/provisioning/' + deviceId,
				auth: auth,
				headers: headers,
				data: {
					deviceID: deviceId,
					publicKey: typeof key === 'string' ? key : key.toString(),
					filename: 'particle-api',
					order: 'manual_' + Date.now(),
					algorithm: algorithm || 'rsa'
				},
				context: context
			});
		}

		/**
   * Call a device function
   * @param {Object} options            Options for this API call
   * @param {String} options.deviceId   Device ID or Name
   * @param {String} options.name       Function name
   * @param {String} options.argument   Function argument
   * @param {String} [options.product]  Device in this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'callFunction',
		value: function callFunction(_ref40) {
			var deviceId = _ref40.deviceId,
			    name = _ref40.name,
			    argument = _ref40.argument,
			    product = _ref40.product,
			    auth = _ref40.auth,
			    headers = _ref40.headers,
			    context = _ref40.context;

			var uri = product ? '/v1/products/' + product + '/devices/' + deviceId + '/' + name : '/v1/devices/' + deviceId + '/' + name;
			return this.post({ uri: uri, auth: auth, headers: headers, data: { args: argument }, context: context });
		}

		/**
   * Get a stream of events
   * @param {Object} options             Options for this API call
   * @param {String} [options.deviceId]  Device ID or Name, or `mine` to indicate only your devices.
   * @param {String} [options.name]      Event Name
   * @param {String} [options.org]       Organization Slug
   * @param {String} [options.product]   Events for this product ID or slug
   * @param {String} options.auth        Access Token
   * @returns {Promise} If the promise resolves, the resolution value will be an EventStream object that will
   * emit 'event' events.
   */

	}, {
		key: 'getEventStream',
		value: function getEventStream(_ref41) {
			var deviceId = _ref41.deviceId,
			    name = _ref41.name,
			    org = _ref41.org,
			    product = _ref41.product,
			    auth = _ref41.auth;

			var uri = '/v1/';
			if (org) {
				uri += 'orgs/' + org + '/';
			}

			if (product) {
				uri += 'products/' + product + '/';
			}

			if (deviceId) {
				uri += 'devices/';
				if (!(deviceId.toLowerCase() === 'mine')) {
					uri += deviceId + '/';
				}
			}

			uri += 'events';

			if (name) {
				uri += '/' + encodeURIComponent(name);
			}

			auth = this._getActiveAuthToken(auth);
			return new _EventStream2.default('' + this.baseUrl + uri, auth).connect();
		}

		/**
   * Publish a event to the Particle Cloud
   * @param {Object} options             Options for this API call
   * @param {String} options.name        Event name
   * @param {String} options.data        Event data
   * @param {Boolean} options.isPrivate  Should the event be publicly available?
   * @param {String} [options.product]   Event for this product ID or slug
   * @param {String} options.auth        Access Token
   * @param {Object} [options.headers]   Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]   Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'publishEvent',
		value: function publishEvent(_ref42) {
			var name = _ref42.name,
			    data = _ref42.data,
			    isPrivate = _ref42.isPrivate,
			    product = _ref42.product,
			    auth = _ref42.auth,
			    headers = _ref42.headers,
			    context = _ref42.context;

			var uri = product ? '/v1/products/' + product + '/events' : '/v1/devices/events';
			var postData = { name: name, data: data, private: isPrivate };
			return this.post({ uri: uri, auth: auth, headers: headers, data: postData, context: context });
		}

		/**
   * Create a webhook
   * @param {Object} options                            Options for this API call
   * @param {String} options.event                      The name of the Particle event that should trigger the Webhook
   * @param {String} options.url                        The web address that will be targeted when the Webhook is triggered
   * @param {String} [options.device]                   Trigger Webhook only for this device ID or Name
   * @param {Boolean} [options.rejectUnauthorized]      Set to `false` to skip SSL certificate validation of the target URL
   * @param {Boolean} [options.noDefaults]              Don't include default event data in the webhook request
   * @param {Object} [options.hook]                     Webhook configuration settings
   * @param {String} [options.hook.method=POST]         Type of web request triggered by the Webhook (GET, POST, PUT, or DELETE)
   * @param {Object} [options.hook.auth]                Auth data like `{ username: 'me', password: '1234' }` to send via basic auth header with the Webhook request
   * @param {Object} [options.hook.headers]             Additional headers to add to the Webhook like `{ 'X-ONE': '1', X-TWO: '2' }`
   * @param {Object} [options.hook.query]               Query params to add to the Webhook request like `{ foo: 'foo', bar: 'bar' }`
   * @param {Object} [options.hook.json]                JSON data to send with the Webhook request - sets `Content-Type` to `application/json`
   * @param {Object} [options.hook.form]                Form data to send with the Webhook request - sets `Content-Type` to `application/x-www-form-urlencoded`
   * @param {String} [options.hook.body]                Custom body to send with the Webhook request
   * @param {Object} [options.hook.responseTemplate]    Template to use to customize the Webhook response body
   * @param {Object} [options.hook.responseEvent]       The Webhook response event name that your devices can subscribe to
   * @param {Object} [options.hook.errorResponseEvent]  The Webhook error response event name that your devices can subscribe to
   * @param {String} [options.product]                  Webhook for this product ID or slug
   * @param {String} options.auth                       Access Token
   * @param {Object} [options.headers]                  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]                  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'createWebhook',
		value: function createWebhook(_ref43) {
			var event = _ref43.event,
			    url = _ref43.url,
			    device = _ref43.device,
			    rejectUnauthorized = _ref43.rejectUnauthorized,
			    noDefaults = _ref43.noDefaults,
			    hook = _ref43.hook,
			    product = _ref43.product,
			    auth = _ref43.auth,
			    headers = _ref43.headers,
			    context = _ref43.context;

			var uri = product ? '/v1/products/' + product + '/webhooks' : '/v1/webhooks';
			var data = { event: event, url: url, deviceId: device, rejectUnauthorized: rejectUnauthorized, noDefaults: noDefaults };

			if (hook) {
				data.requestType = hook.method;
				data.auth = hook.auth;
				data.headers = hook.headers;
				data.query = hook.query;
				data.json = hook.json;
				data.form = hook.form;
				data.body = hook.body;
				data.responseTemplate = hook.responseTemplate;
				data.responseTopic = hook.responseEvent;
				data.errorResponseTopic = hook.errorResponseEvent;
			}

			if (!data.requestType) {
				data.requestType = 'POST';
			}

			return this.post({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Delete a webhook
   * @param {Object} options            Options for this API call
   * @param {String} options.hookId     Webhook ID
   * @param {String} [options.product]  Webhook for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteWebhook',
		value: function deleteWebhook(_ref44) {
			var hookId = _ref44.hookId,
			    product = _ref44.product,
			    auth = _ref44.auth,
			    headers = _ref44.headers,
			    context = _ref44.context;

			var uri = product ? '/v1/products/' + product + '/webhooks/' + hookId : '/v1/webhooks/' + hookId;
			return this.delete({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * List all webhooks owned by the account or product
   * @param {Object} options            Options for this API call
   * @param {String} [options.product]  Webhooks for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listWebhooks',
		value: function listWebhooks(_ref45) {
			var product = _ref45.product,
			    auth = _ref45.auth,
			    headers = _ref45.headers,
			    context = _ref45.context;

			var uri = product ? '/v1/products/' + product + '/webhooks' : '/v1/webhooks';
			return this.get({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Create an integration to send events to an external service
      *
   * See the API docs for details https://docs.particle.io/reference/api/#integrations-webhooks-
   *
   * @param {Object} options             Options for this API call
   * @param {String} options.event       Event that triggers the integration
   * @param {Object} options.settings    Settings specific to that integration type
   * @param {String} [options.deviceId]  Trigger integration only for this device ID or Name
   * @param {String} [options.product]   Integration for this product ID or slug
   * @param {String} options.auth        Access Token
   * @param {Object} [options.headers]   Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'createIntegration',
		value: function createIntegration(_ref46) {
			var event = _ref46.event,
			    settings = _ref46.settings,
			    deviceId = _ref46.deviceId,
			    product = _ref46.product,
			    auth = _ref46.auth,
			    headers = _ref46.headers,
			    context = _ref46.context;

			var uri = product ? '/v1/products/' + product + '/integrations' : '/v1/integrations';
			var data = (0, _assign2.default)({ event: event, deviceid: deviceId }, settings);
			return this.post({ uri: uri, data: data, auth: auth, headers: headers, context: context });
		}

		/**
   * Edit an integration to send events to an external service
   *
   * See the API docs for details https://docs.particle.io/reference/api/#integrations-webhooks-
   *
   * @param {Object} options                Options for this API call
   * @param {String} options.integrationId  The integration to edit
   * @param {String} [options.event]        Change the event that triggers the integration
   * @param {Object} [options.settings]     Change the settings specific to that integration type
   * @param {String} [options.deviceId]     Trigger integration only for this device ID or Name
   * @param {String} [options.product]      Integration for this product ID or slug
   * @param {String} options.auth           Access Token
   * @param {Object} [options.headers]      Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]      Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'editIntegration',
		value: function editIntegration(_ref47) {
			var integrationId = _ref47.integrationId,
			    event = _ref47.event,
			    settings = _ref47.settings,
			    deviceId = _ref47.deviceId,
			    product = _ref47.product,
			    auth = _ref47.auth,
			    headers = _ref47.headers,
			    context = _ref47.context;

			var uri = product ? '/v1/products/' + product + '/integrations/' + integrationId : '/v1/integrations/' + integrationId;
			var data = (0, _assign2.default)({ event: event, deviceid: deviceId }, settings);
			return this.put({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Delete an integration to send events to an external service
   *
   * @param {Object} options                Options for this API call
   * @param {String} options.integrationId  The integration to remove
   * @param {String} [options.product]      Integration for this product ID or slug
   * @param {String} options.auth           Access Token
   * @param {Object} [options.headers]      Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]      Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteIntegration',
		value: function deleteIntegration(_ref48) {
			var integrationId = _ref48.integrationId,
			    product = _ref48.product,
			    auth = _ref48.auth,
			    headers = _ref48.headers,
			    context = _ref48.context;

			var uri = product ? '/v1/products/' + product + '/integrations/' + integrationId : '/v1/integrations/' + integrationId;
			return this.delete({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * List all integrations owned by the account or product
   * @param {Object} options            Options for this API call
   * @param {String} [options.product]  Integrations for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listIntegrations',
		value: function listIntegrations(_ref49) {
			var product = _ref49.product,
			    auth = _ref49.auth,
			    headers = _ref49.headers,
			    context = _ref49.context;

			var uri = product ? '/v1/products/' + product + '/integrations' : '/v1/integrations';
			return this.get({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Get details about the current user
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getUserInfo',
		value: function getUserInfo(_ref50) {
			var auth = _ref50.auth,
			    headers = _ref50.headers,
			    context = _ref50.context;

			return this.get({ uri: '/v1/user', auth: auth, headers: headers, context: context });
		}

		/**
   * Set details on the current user
   * @param {Object} options              Options for this API call
   * @param {String} options.auth         Access Token
   * @param {String} options.accountInfo  Set user's extended info fields (name, business account, company name, etc)
   * @param {Object} [options.headers]    Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]    Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'setUserInfo',
		value: function setUserInfo(_ref51) {
			var accountInfo = _ref51.accountInfo,
			    auth = _ref51.auth,
			    headers = _ref51.headers,
			    context = _ref51.context;

			var data = { account_info: accountInfo };
			return this.put({ uri: '/v1/user', auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Change username (i.e, email)
   * @param {Object} options                  Options for this API call
   * @param {String} options.auth             Access Token
   * @param {String} options.currentPassword  Current password
   * @param {String} options.username         New email
   * @param {Boolean} options.invalidateTokens Should all tokens be invalidated
   * @param {Object} [options.headers]        Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]        Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'changeUsername',
		value: function changeUsername(_ref52) {
			var currentPassword = _ref52.currentPassword,
			    username = _ref52.username,
			    _ref52$invalidateToke = _ref52.invalidateTokens,
			    invalidateTokens = _ref52$invalidateToke === undefined ? false : _ref52$invalidateToke,
			    auth = _ref52.auth,
			    headers = _ref52.headers,
			    context = _ref52.context;

			var data = { username: username, current_password: currentPassword };

			if (invalidateTokens) {
				data.invalidate_tokens = true;
			}

			return this.put({ uri: '/v1/user', auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Change user's password
   * @param {Object} options                   Options for this API call
   * @param {String} options.auth              Access Token
   * @param {String} options.currentPassword   Current password
   * @param {String} options.password          New password
   * @param {Boolean} options.invalidateTokens Should all tokens be invalidated
   * @param {Object} [options.headers]         Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]         Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'changeUserPassword',
		value: function changeUserPassword(_ref53) {
			var currentPassword = _ref53.currentPassword,
			    password = _ref53.password,
			    _ref53$invalidateToke = _ref53.invalidateTokens,
			    invalidateTokens = _ref53$invalidateToke === undefined ? false : _ref53$invalidateToke,
			    auth = _ref53.auth,
			    headers = _ref53.headers,
			    context = _ref53.context;

			var data = { password: password, current_password: currentPassword };

			if (invalidateTokens) {
				data.invalidate_tokens = true;
			}

			return this.put({ uri: '/v1/user', auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * List SIM cards owned by a user or product
   * @param {Object} options               Options for this API call
   * @param {String} [options.iccid]       (Product only) Filter to SIM cards matching this ICCID
   * @param {String} [options.deviceId]    (Product only) Filter to SIM cards matching this device ID
   * @param {String} [options.deviceName]  (Product only) Filter to SIM cards matching this device name
   * @param {Number} [options.page]        (Product only) Current page of results
   * @param {Number} [options.perPage]     (Product only) Records per page
   * @param {String} [options.product]     SIM cards for this product ID or slug
   * @param {String} options.auth          Access Token
   * @param {Object} [options.headers]     Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]     Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listSIMs',
		value: function listSIMs(_ref54) {
			var iccid = _ref54.iccid,
			    deviceId = _ref54.deviceId,
			    deviceName = _ref54.deviceName,
			    page = _ref54.page,
			    perPage = _ref54.perPage,
			    product = _ref54.product,
			    auth = _ref54.auth,
			    headers = _ref54.headers,
			    context = _ref54.context;

			var uri = product ? '/v1/products/' + product + '/sims' : '/v1/sims';
			var query = product ? { iccid: iccid, deviceId: deviceId, deviceName: deviceName, page: page, per_page: perPage } : undefined;
			return this.get({ uri: uri, auth: auth, headers: headers, query: query, context: context });
		}

		/**
   * Get data usage for one SIM card for the current billing period
   * @param {Object} options            Options for this API call
   * @param {String} options.iccid      ICCID of the SIM card
   * @param {String} [options.product]  SIM card for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getSIMDataUsage',
		value: function getSIMDataUsage(_ref55) {
			var iccid = _ref55.iccid,
			    product = _ref55.product,
			    auth = _ref55.auth,
			    headers = _ref55.headers,
			    context = _ref55.context;

			var uri = product ? '/v1/products/' + product + '/sims/' + iccid + '/data_usage' : '/v1/sims/' + iccid + '/data_usage';

			return this.get({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Get data usage for all SIM cards in a product the current billing period
   * @param {Object} options            Options for this API call
   * @param {String} options.product    SIM cards for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getFleetDataUsage',
		value: function getFleetDataUsage(_ref56) {
			var product = _ref56.product,
			    auth = _ref56.auth,
			    headers = _ref56.headers,
			    context = _ref56.context;

			return this.get({
				uri: '/v1/products/' + product + '/sims/data_usage',
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Check SIM status
   * @param {Object} options            Options for this API call
   * @param {String} options.iccid      ICCID of the SIM card
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'checkSIM',
		value: function checkSIM(_ref57) {
			var iccid = _ref57.iccid,
			    auth = _ref57.auth,
			    headers = _ref57.headers,
			    context = _ref57.context;

			return this.head({ uri: '/v1/sims/' + iccid, auth: auth, headers: headers, context: context });
		}

		/**
   * Activate and add SIM cards to an account or product
   * @param {Object} options                Options for this API call
   * @param {String} options.iccid          ICCID of the SIM card
   * @param {Array<String>} options.iccids  (Product only) ICCID of multiple SIM cards to import
   * @param {String} options.country        The ISO country code for the SIM cards
   * @param {String} [options.product]      SIM cards for this product ID or slug
   * @param {String} options.auth           Access Token
   * @param {Object} [options.headers]      Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]      Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'activateSIM',
		value: function activateSIM(_ref58) {
			var iccid = _ref58.iccid,
			    iccids = _ref58.iccids,
			    country = _ref58.country,
			    promoCode = _ref58.promoCode,
			    product = _ref58.product,
			    auth = _ref58.auth,
			    headers = _ref58.headers,
			    context = _ref58.context;

			// promoCode is deprecated
			iccids = iccids || [iccid];
			var uri = product ? '/v1/products/' + product + '/sims' : '/v1/sims/' + iccid;
			var data = product ? { sims: iccids, country: country } : { country: country, promoCode: promoCode, action: 'activate' };
			var method = product ? 'post' : 'put';

			return this.request({ uri: uri, method: method, headers: headers, data: data, auth: auth, context: context });
		}

		/**
   * Deactivate a SIM card so it doesn't incur data usage in future months.
   * @param {Object} options            Options for this API call
   * @param {String} options.iccid      ICCID of the SIM card
   * @param {String} [options.product]  SIM cards for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deactivateSIM',
		value: function deactivateSIM(_ref59) {
			var iccid = _ref59.iccid,
			    product = _ref59.product,
			    auth = _ref59.auth,
			    headers = _ref59.headers,
			    context = _ref59.context;

			var uri = product ? '/v1/products/' + product + '/sims/' + iccid : '/v1/sims/' + iccid;
			var data = { action: 'deactivate' };
			return this.put({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Reactivate a SIM card the was deactivated or unpause a SIM card that was automatically paused
   * @param {Object} options            Options for this API call
   * @param {String} options.iccid      ICCID of the SIM card
   * @param {Number} [options.mbLimit]  New monthly data limit. Necessary if unpausing a SIM card
   * @param {String} [options.product]  SIM cards for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'reactivateSIM',
		value: function reactivateSIM(_ref60) {
			var iccid = _ref60.iccid,
			    mbLimit = _ref60.mbLimit,
			    product = _ref60.product,
			    auth = _ref60.auth,
			    headers = _ref60.headers,
			    context = _ref60.context;

			var uri = product ? '/v1/products/' + product + '/sims/' + iccid : '/v1/sims/' + iccid;
			var data = { mb_limit: mbLimit, action: 'reactivate' };
			return this.put({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Update SIM card data limit
   * @param {Object} options            Options for this API call
   * @param {String} options.iccid      ICCID of the SIM card
   * @param {Array}  options.mbLimit    Data limit in megabyte for the SIM card
   * @param {String} [options.product]  SIM cards for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'updateSIM',
		value: function updateSIM(_ref61) {
			var iccid = _ref61.iccid,
			    mbLimit = _ref61.mbLimit,
			    product = _ref61.product,
			    auth = _ref61.auth,
			    headers = _ref61.headers,
			    context = _ref61.context;

			var uri = product ? '/v1/products/' + product + '/sims/' + iccid : '/v1/sims/' + iccid;
			var data = { mb_limit: mbLimit };
			return this.put({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Remove a SIM card from an account so it can be activated by a different account
   * @param {Object} options            Options for this API call
   * @param {String} options.iccid      ICCID of the SIM card
   * @param {String} [options.product]  SIM cards for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'removeSIM',
		value: function removeSIM(_ref62) {
			var iccid = _ref62.iccid,
			    product = _ref62.product,
			    auth = _ref62.auth,
			    headers = _ref62.headers,
			    context = _ref62.context;

			var uri = product ? '/v1/products/' + product + '/sims/' + iccid : '/v1/sims/' + iccid;
			return this.delete({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * List valid build targets to be used for compiling
   * @param {Object} options                        Options for this API call
   * @param {Boolean} [options.onlyFeatured=false]  Only list featured build targets
   * @param {String} options.auth                   Access Token
   * @param {Object} [options.headers]              Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]              Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listBuildTargets',
		value: function listBuildTargets(_ref63) {
			var onlyFeatured = _ref63.onlyFeatured,
			    auth = _ref63.auth,
			    headers = _ref63.headers,
			    context = _ref63.context;

			var query = onlyFeatured ? { featured: !!onlyFeatured } : undefined;
			return this.get({ uri: '/v1/build_targets', auth: auth, headers: headers, query: query, context: context });
		}

		/**
   * List firmware libraries
   * @param  {Object} options Options for this API call
   * @param  {Number} options.page Page index (default, first page)
   * @param  {Number} options.limit Number of items per page
   * @param  {String} options.filter Search term for the libraries
   * @param  {String} options.sort Ordering key for the library list
   * @param  {Array<String>}  options.architectures List of architectures to filter
   * @param  {String} options.category Category to filter
   * @param  {String} options.scope The library scope to list. Default is 'all'. Other values are
   * - 'all' - list public libraries and my private libraries
   * - 'public' - list only public libraries
   * - 'private' - list only my private libraries
   * - 'mine' - list my libraries (public and private)
   * - 'official' - list only official libraries
   * - 'verified' - list only verified libraries
   * - 'featured' - list only featured libraries
   * @param  {String} options.excludeScopes  list of scopes to exclude
   * @param  {String} options.category Category to filter
   * @param  {String} options.auth Access Token
   * @param {Object} [options.headers]              Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]              Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listLibraries',
		value: function listLibraries(_ref64) {
			var page = _ref64.page,
			    limit = _ref64.limit,
			    filter = _ref64.filter,
			    sort = _ref64.sort,
			    architectures = _ref64.architectures,
			    category = _ref64.category,
			    scope = _ref64.scope,
			    excludeScopes = _ref64.excludeScopes,
			    auth = _ref64.auth,
			    headers = _ref64.headers,
			    context = _ref64.context;

			return this.get({
				uri: '/v1/libraries',
				auth: auth,
				headers: headers,
				query: {
					page: page,
					filter: filter,
					limit: limit,
					sort: sort,
					architectures: this._asList(architectures),
					category: category,
					scope: scope,
					excludeScopes: this._asList(excludeScopes)
				},
				context: context
			});
		}
	}, {
		key: '_asList',
		value: function _asList(value) {
			return Array.isArray(value) ? value.join(',') : value;
		}

		/**
   * Get firmware library details
   * @param {Object} options            Options for this API call
   * @param {String} options.name       Name of the library to fetch
   * @param {String} options.version    Version of the library to fetch (default: latest)
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getLibrary',
		value: function getLibrary(_ref65) {
			var name = _ref65.name,
			    version = _ref65.version,
			    auth = _ref65.auth,
			    headers = _ref65.headers,
			    context = _ref65.context;

			return this.get({
				uri: '/v1/libraries/' + name,
				auth: auth,
				headers: headers,
				query: { version: version },
				context: context
			});
		}

		/**
   * Firmware library details for each version
   * @param {Object} options            Options for this API call
   * @param {String} options.name       Name of the library to fetch
   * @param {Number} options.page       Page index (default, first page)
   * @param {Number} options.limit      Number of items per page
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getLibraryVersions',
		value: function getLibraryVersions(_ref66) {
			var name = _ref66.name,
			    page = _ref66.page,
			    limit = _ref66.limit,
			    auth = _ref66.auth,
			    headers = _ref66.headers,
			    context = _ref66.context;

			return this.get({
				uri: '/v1/libraries/' + name + '/versions',
				auth: auth,
				headers: headers,
				query: { page: page, limit: limit },
				context: context
			});
		}

		/**
   * Contribute a new library version from a compressed archive
   * @param {Object} options            Options for this API call
   * @param {String} options.archive    Compressed archive file containing the library sources
   *                                    Either a path or Buffer of the file contents in Node, or a File or Blob in the browser.
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'contributeLibrary',
		value: function contributeLibrary(_ref67) {
			var archive = _ref67.archive,
			    auth = _ref67.auth,
			    headers = _ref67.headers,
			    context = _ref67.context;

			var files = {
				'archive.tar.gz': archive
			};

			return this.request({
				uri: '/v1/libraries',
				method: 'post',
				auth: auth,
				headers: headers,
				files: files,
				context: context
			});
		}

		/**
   * Publish the latest version of a library to the public
   * @param {Object} options            Options for this API call
   * @param {String} options.name       Name of the library to publish
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'publishLibrary',
		value: function publishLibrary(_ref68) {
			var name = _ref68.name,
			    auth = _ref68.auth,
			    headers = _ref68.headers,
			    context = _ref68.context;

			return this.request({
				uri: '/v1/libraries/' + name,
				method: 'patch',
				auth: auth,
				headers: headers,
				data: { visibility: 'public' },
				context: context
			});
		}

		/**
   * Delete one version of a library or an entire private library
   * @param {Object} options            Options for this API call
   * @param {String} options.name       Name of the library to remove
   * @param {String} options.force      Key to force deleting a public library
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteLibrary',
		value: function deleteLibrary(_ref69) {
			var name = _ref69.name,
			    force = _ref69.force,
			    auth = _ref69.auth,
			    headers = _ref69.headers,
			    context = _ref69.context;

			return this.delete({
				uri: '/v1/libraries/' + name,
				auth: auth,
				headers: headers,
				data: { force: force },
				context: context
			});
		}

		/**
   * Download an external file that may not be on the API
   * @param {Object} options            Options for this API call
   * @param {String} options.uri        URL of the file.
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} Resolves to a buffer with the file data
   */

	}, {
		key: 'downloadFile',
		value: function downloadFile(_ref70) {
			var uri = _ref70.uri,
			    headers = _ref70.headers,
			    context = _ref70.context;

			var req = this.request({ uri: uri, method: 'get', headers: headers, context: context, raw: true });
			return this._provideFileData(req);
		}

		/**
   * List OAuth client created by the account
   * @param {Object} options            Options for this API call
   * @param {String} [options.product]  List clients for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listOAuthClients',
		value: function listOAuthClients(_ref71) {
			var product = _ref71.product,
			    auth = _ref71.auth,
			    headers = _ref71.headers,
			    context = _ref71.context;

			var uri = product ? '/v1/products/' + product + '/clients' : '/v1/clients';
			return this.get({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * Create an OAuth client
   * @param {Object} options                 Options for this API call
   * @param {String} options.name            Name of the OAuth client
   * @param {String} options.type            web, installed or web
   * @param {String} [options.redirect_uri]  URL to redirect after OAuth flow. Only for type web.
   * @param {Object} [options.scope]         Limits what the access tokens created by this client can do.
   * @param {String} [options.product]       Create client for this product ID or slug
   * @param {String} options.auth            Access Token
   * @param {Object} [options.headers]       Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]       Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'createOAuthClient',
		value: function createOAuthClient(_ref72) {
			var name = _ref72.name,
			    type = _ref72.type,
			    redirect_uri = _ref72.redirect_uri,
			    scope = _ref72.scope,
			    product = _ref72.product,
			    auth = _ref72.auth,
			    headers = _ref72.headers,
			    context = _ref72.context;

			var uri = product ? '/v1/products/' + product + '/clients' : '/v1/clients';
			var data = { name: name, type: type, redirect_uri: redirect_uri, scope: scope };
			return this.post({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}

		/**
   * Update an OAuth client
   * @param {Object} options            Options for this API call
   * @param {String} options.clientId   The OAuth client to update
   * @param {String} [options.name]     New Name of the OAuth client
   * @param {Object} [options.scope]    New scope of the OAuth client
   * @param {String} [options.product]  Update client linked to this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'updateOAuthClient',
		value: function updateOAuthClient(_ref73) {
			var clientId = _ref73.clientId,
			    name = _ref73.name,
			    scope = _ref73.scope,
			    product = _ref73.product,
			    auth = _ref73.auth,
			    headers = _ref73.headers,
			    context = _ref73.context;

			var uri = product ? '/v1/products/' + product + '/clients/' + clientId : '/v1/clients/' + clientId;
			var data = { name: name, scope: scope };
			return this.put({ uri: uri, data: data, auth: auth, headers: headers, context: context });
		}

		/**
   * Delete an OAuth client
   * @param {Object} options            Options for this API call
   * @param {String} options.clientId   The OAuth client to update
   * @param {String} [options.product]  OAuth client linked to this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'deleteOAuthClient',
		value: function deleteOAuthClient(_ref74) {
			var clientId = _ref74.clientId,
			    product = _ref74.product,
			    auth = _ref74.auth,
			    headers = _ref74.headers,
			    context = _ref74.context;

			var uri = product ? '/v1/products/' + product + '/clients/' + clientId : '/v1/clients/' + clientId;
			return this.delete({ uri: uri, auth: auth, headers: headers, context: context });
		}

		/**
   * List products the account has access to
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listProducts',
		value: function listProducts(_ref75) {
			var auth = _ref75.auth,
			    headers = _ref75.headers,
			    context = _ref75.context;

			return this.get({ uri: '/v1/products', auth: auth, headers: headers, context: context });
		}

		/**
   * Get detailed information about a product
   * @param {Object} options            Options for this API call
   * @param {String} options.product    Product ID or slug
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProduct',
		value: function getProduct(_ref76) {
			var product = _ref76.product,
			    auth = _ref76.auth,
			    headers = _ref76.headers,
			    context = _ref76.context;

			return this.get({ uri: '/v1/products/' + product, auth: auth, headers: headers, context: context });
		}

		/**
   * List product firmware versions
   * @param {Object} options            Options for this API call
   * @param {String} options.product    Firmware for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listProductFirmware',
		value: function listProductFirmware(_ref77) {
			var product = _ref77.product,
			    auth = _ref77.auth,
			    headers = _ref77.headers,
			    context = _ref77.context;

			return this.get({ uri: '/v1/products/' + product + '/firmware', auth: auth, headers: headers, context: context });
		}

		/**
   * List product firmware versions
   * @param {Object} options                Options for this API call
   * @param {Object} options.file           Path or Buffer of the new firmware file
   *                                        Either a path or Buffer of the file contents in Node, or a File or Blob in the browser.
   * @param {Number} options.version        Version number of new firmware
   * @param {String} options.title          Short identifier for the new firmware
   * @param {String} [options.description]  Longer description for the new firmware
   * @param {String} options.product        Firmware for this product ID or slug
   * @param {String} options.auth           Access Token
   * @param {Object} [options.headers]      Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]      Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'uploadProductFirmware',
		value: function uploadProductFirmware(_ref78) {
			var file = _ref78.file,
			    version = _ref78.version,
			    title = _ref78.title,
			    description = _ref78.description,
			    product = _ref78.product,
			    auth = _ref78.auth,
			    headers = _ref78.headers,
			    context = _ref78.context;

			return this.request({
				uri: '/v1/products/' + product + '/firmware',
				method: 'post',
				auth: auth,
				headers: headers,
				form: {
					version: version,
					title: title,
					description: description
				},
				files: {
					'firmware.bin': file
				},
				context: context
			});
		}

		/**
   * Get information about a product firmware version
   * @param {Object} options            Options for this API call
   * @param {Number} options.version    Version number of firmware
   * @param {String} options.product    Firmware for this product ID or slug
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductFirmware',
		value: function getProductFirmware(_ref79) {
			var version = _ref79.version,
			    product = _ref79.product,
			    auth = _ref79.auth,
			    headers = _ref79.headers,
			    context = _ref79.context;

			return this.get({
				uri: '/v1/products/' + product + '/firmware/' + version,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Update information for a product firmware version
   * @param {Object} options                Options for this API call
   * @param {Number} options.version        Version number of new firmware
   * @param {String} [options.title]        New title
   * @param {String} [options.description]  New description
   * @param {String} options.product        Firmware for this product ID or slug
   * @param {String} options.auth           Access Token
   * @param {Object} [options.headers]      Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]      Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'updateProductFirmware',
		value: function updateProductFirmware(_ref80) {
			var version = _ref80.version,
			    title = _ref80.title,
			    description = _ref80.description,
			    product = _ref80.product,
			    auth = _ref80.auth,
			    headers = _ref80.headers,
			    context = _ref80.context;

			var uri = '/v1/products/' + product + '/firmware/' + version;
			return this.put({ uri: uri, auth: auth, headers: headers, data: { title: title, description: description }, context: context });
		}

		/**
   * Download a product firmware binary
   * @param {Object} options            Options for this API call
   * @param {Number} options.version    Version number of new firmware
   * @param {String} options.product    Firmware for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Request} A promise
   */

	}, {
		key: 'downloadProductFirmware',
		value: function downloadProductFirmware(_ref81) {
			var version = _ref81.version,
			    product = _ref81.product,
			    auth = _ref81.auth,
			    headers = _ref81.headers,
			    context = _ref81.context;

			var req = this.request({
				uri: '/v1/products/' + product + '/firmware/' + version + '/binary',
				method: 'get',
				auth: auth,
				headers: headers,
				context: context,
				raw: true
			});

			return this._provideFileData(req);
		}
	}, {
		key: '_provideFileData',
		value: function _provideFileData(req) {
			if (this.agent.isForBrowser()) {
				req = req.responseType('arraybuffer').then(function (res) {
					res.body = res.xhr.response;
					return res;
				});
			} else {
				req = req.buffer(true).parse(_superagentBinaryParser2.default);
			}
			return req.then(function (res) {
				return res.body;
			});
		}

		/**
   * Release a product firmware version as the default version
   * @param {Object} options            Options for this API call
   * @param {Number} options.version    Version number of new firmware
   * @param {String} options.product    Firmware for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'releaseProductFirmware',
		value: function releaseProductFirmware(_ref82) {
			var version = _ref82.version,
			    product = _ref82.product,
			    auth = _ref82.auth,
			    headers = _ref82.headers,
			    context = _ref82.context;

			var uri = '/v1/products/' + product + '/firmware/release';
			return this.put({ uri: uri, auth: auth, headers: headers, data: { version: version }, context: context });
		}

		/**
   * List product team members
   * @param {Object} options            Options for this API call
   * @param {String} options.product    Team for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'listTeamMembers',
		value: function listTeamMembers(_ref83) {
			var product = _ref83.product,
			    auth = _ref83.auth,
			    headers = _ref83.headers,
			    context = _ref83.context;

			return this.get({
				uri: '/v1/products/' + product + '/team',
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Invite Particle user to a product team
   * @param {Object} options            Options for this API call
   * @param {String} options.username   Username for the Particle account
   * @param {String} options.product    Team for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'inviteTeamMember',
		value: function inviteTeamMember(_ref84) {
			var username = _ref84.username,
			    product = _ref84.product,
			    auth = _ref84.auth,
			    headers = _ref84.headers,
			    context = _ref84.context;

			return this.post({
				uri: '/v1/products/' + product + '/team',
				auth: auth,
				headers: headers,
				data: { username: username },
				context: context
			});
		}

		/**
   * Remove Particle user to a product team
   * @param {Object} options            Options for this API call
   * @param {String} options.username   Username for the Particle account
   * @param {String} options.product    Team for this product ID or slug
   * @param {String} options.auth       Access Token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'removeTeamMember',
		value: function removeTeamMember(_ref85) {
			var username = _ref85.username,
			    product = _ref85.product,
			    auth = _ref85.auth,
			    headers = _ref85.headers,
			    context = _ref85.context;

			return this.delete({
				uri: '/v1/products/' + product + '/team/' + username,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Fetch details about a serial number
   * @param {Object} options               Options for this API call
   * @param {String} options.serialNumber  The serial number printed on the barcode of the device packaging
   * @param {String} options.auth          Access Token
   * @param {Object} [options.headers]     Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]     Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'lookupSerialNumber',
		value: function lookupSerialNumber(_ref86) {
			var serialNumber = _ref86.serialNumber,
			    auth = _ref86.auth,
			    headers = _ref86.headers,
			    context = _ref86.context;

			return this.get({
				uri: '/v1/serial_numbers/' + serialNumber,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Create a mesh network
   * @param {Object} options            Options for this API call
   * @param {String} options.name       Network name
   * @param {String} options.deviceId   Gateway device ID
   * @param {String} [options.iccid]    ICCID of the active SIM card (only for cellular gateway devices)
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'createMeshNetwork',
		value: function createMeshNetwork(_ref87) {
			var name = _ref87.name,
			    deviceId = _ref87.deviceId,
			    iccid = _ref87.iccid,
			    auth = _ref87.auth,
			    headers = _ref87.headers,
			    context = _ref87.context;

			return this.post({
				uri: '/v1/networks',
				auth: auth,
				headers: headers,
				data: { name: name, device_id: deviceId, iccid: iccid },
				context: context
			});
		}

		/**
   * Remove a mesh network.
   * @param {Object} options            Options for this API call
   * @param {String} options.networkId  Network ID or name
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'removeMeshNetwork',
		value: function removeMeshNetwork(_ref88) {
			var networkId = _ref88.networkId,
			    auth = _ref88.auth,
			    headers = _ref88.headers,
			    context = _ref88.context;

			return this.delete({ uri: '/v1/networks/' + networkId, auth: auth, headers: headers, context: context });
		}

		/**
   * List all mesh networks
   * @param {Object} options            Options for this API call
   * @param {String} options.auth       Access token
   * @param {Number} [options.page]     Current page of results
   * @param {Number} [options.perPage]  Records per page
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'listMeshNetworks',
		value: function listMeshNetworks(_ref89) {
			var page = _ref89.page,
			    perPage = _ref89.perPage,
			    auth = _ref89.auth,
			    headers = _ref89.headers,
			    context = _ref89.context;

			var query = page ? { page: page, per_page: perPage } : undefined;
			return this.get({ uri: '/v1/networks', auth: auth, headers: headers, query: query, context: context });
		}

		/**
   * Get information about a mesh network.
   * @param {Object} options            Options for this API call
   * @param {String} options.networkId  Network ID or name
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'getMeshNetwork',
		value: function getMeshNetwork(_ref90) {
			var networkId = _ref90.networkId,
			    auth = _ref90.auth,
			    headers = _ref90.headers,
			    context = _ref90.context;

			return this.get({ uri: '/v1/networks/' + networkId, auth: auth, headers: headers, context: context });
		}

		/**
   * Modify a mesh network.
   * @param {Object} options            Options for this API call
   * @param {String} options.networkId  Network ID or name
   * @param {String} options.action     'add-device', 'remove-device', 'gateway-enable' or 'gateway-disable'
   * @param {String} options.deviceId   Device ID
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'updateMeshNetwork',
		value: function updateMeshNetwork(_ref91) {
			var networkId = _ref91.networkId,
			    action = _ref91.action,
			    deviceId = _ref91.deviceId,
			    auth = _ref91.auth,
			    headers = _ref91.headers,
			    context = _ref91.context;

			return this.put({
				uri: '/v1/networks/' + networkId,
				auth: auth,
				headers: headers,
				data: { action: action, device_id: deviceId },
				context: context
			});
		}

		/**
   * Add a device to a mesh network.
   * @param {Object} options            Options for this API call
   * @param {String} options.networkId  Network ID or name
   * @param {String} options.deviceId   Device ID
   * @param {String} options.auth       Access token
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'addMeshNetworkDevice',
		value: function addMeshNetworkDevice(_ref92) {
			var networkId = _ref92.networkId,
			    deviceId = _ref92.deviceId,
			    auth = _ref92.auth,
			    headers = _ref92.headers,
			    context = _ref92.context;

			return this.updateMeshNetwork({
				action: 'add-device',
				networkId: networkId,
				deviceId: deviceId,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Remove a device from a mesh network.
   * @param {Object} options              Options for this API call
   * @param {String} [options.networkId]  Network ID or name
   * @param {String} options.deviceId     Device ID
   * @param {String} options.auth         Access token
   * @param {Object} [options.headers]    Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]    Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'removeMeshNetworkDevice',
		value: function removeMeshNetworkDevice(_ref93) {
			var networkId = _ref93.networkId,
			    deviceId = _ref93.deviceId,
			    auth = _ref93.auth,
			    headers = _ref93.headers,
			    context = _ref93.context;

			if (!networkId) {
				return this.delete({
					uri: '/v1/devices/' + deviceId + '/network',
					auth: auth,
					headers: headers, context: context
				});
			}
			return this.updateMeshNetwork({
				action: 'remove-device',
				networkId: networkId,
				deviceId: deviceId,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * List all devices of a mesh network.
   * @param {Object} options            Options for this API call
   * @param {String} options.networkId  Network ID or name
   * @param {String} options.auth       Access token
   * @param {Number} [options.role]     Device role: 'gateway' or 'node'
   * @param {Number} [options.page]     Current page of results
   * @param {Number} [options.perPage]  Records per page
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise<Object>} A promise
   */

	}, {
		key: 'listMeshNetworkDevices',
		value: function listMeshNetworkDevices(_ref94) {
			var networkId = _ref94.networkId,
			    role = _ref94.role,
			    page = _ref94.page,
			    perPage = _ref94.perPage,
			    auth = _ref94.auth,
			    headers = _ref94.headers,
			    context = _ref94.context;

			var query = role || page ? { role: role, page: page, per_page: perPage } : undefined;
			return this.get({
				uri: '/v1/networks/' + networkId + '/devices',
				auth: auth,
				headers: headers,
				query: query,
				context: context
			});
		}

		/**
   * Get product configuration
   * @param  {Object} options          Options for this API call
   * @param  {String} options.product  Config for this product ID or slug
   * @param  {String} options.auth     Access Token
   * @param {Object} [options.headers] Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context] Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductConfiguration',
		value: function getProductConfiguration(_ref95) {
			var auth = _ref95.auth,
			    product = _ref95.product,
			    headers = _ref95.headers,
			    context = _ref95.context;

			return this.get({
				uri: '/v1/products/' + product + '/config',
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Get product configuration schema
   * @param  {Object} options          Options for this API call
   * @param  {String} options.product  Config for this product ID or slug
   * @param  {String} options.auth     Access Token
   * @param {Object} [options.headers] Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context] Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductConfigurationSchema',
		value: function getProductConfigurationSchema(_ref96) {
			var auth = _ref96.auth,
			    product = _ref96.product,
			    _ref96$headers = _ref96.headers,
			    headers = _ref96$headers === undefined ? {} : _ref96$headers,
			    context = _ref96.context;

			headers.accept = 'application/schema+json';
			return this.get({
				uri: '/v1/products/' + product + '/config',
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Get product device's configuration
   * @param  {Object} options          Options for this API call
   * @param  {String} options.product  Config for this product ID or slug
   * @param  {String} options.auth     Access Token
   * @param  {String} options.deviceId Device ID to access
   * @param {Object} [options.headers] Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context] Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductDeviceConfiguration',
		value: function getProductDeviceConfiguration(_ref97) {
			var auth = _ref97.auth,
			    product = _ref97.product,
			    deviceId = _ref97.deviceId,
			    headers = _ref97.headers,
			    context = _ref97.context;

			return this.get({
				uri: '/v1/products/' + product + '/config/' + deviceId,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Get product device's configuration schema
   * @param  {Object} options          Options for this API call
   * @param  {String} options.product  Config for this product ID or slug
   * @param  {String} options.auth     Access Token
   * @param  {String} options.deviceId Device ID to access
   * @param {Object} [options.headers] Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context] Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductDeviceConfigurationSchema',
		value: function getProductDeviceConfigurationSchema(_ref98) {
			var auth = _ref98.auth,
			    product = _ref98.product,
			    deviceId = _ref98.deviceId,
			    headers = _ref98.headers,
			    context = _ref98.context;

			headers.accept = 'application/schema+json';
			return this.get({
				uri: '/v1/products/' + product + '/config/' + deviceId,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Set product configuration
   * @param  {Object} options          Options for this API call
   * @param  {String} options.product  Config for this product ID or slug
   * @param  {String} options.auth     Access Token
   * @param  {Object} opitons.config   Product configuration to update
   * @param {Object} [options.headers] Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context] Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'setProductConfiguration',
		value: function setProductConfiguration(_ref99) {
			var auth = _ref99.auth,
			    product = _ref99.product,
			    config = _ref99.config,
			    headers = _ref99.headers,
			    context = _ref99.context;

			return this.put({
				uri: '/v1/products/' + product + '/config',
				auth: auth,
				data: config,
				headers: headers,
				context: context
			});
		}

		/**
   * Set product configuration for a specific device within the product
   * @param  {Object} options          Options for this API call
   * @param  {String} options.product  Config for this product ID or slug
   * @param  {String} options.auth     Access Token
   * @param  {Object} opitons.config   Product configuration to update
   * @param  {String} options.deviceId Device ID to access
   * @param {Object} [options.headers] Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context] Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'setProductDeviceConfiguration',
		value: function setProductDeviceConfiguration(_ref100) {
			var auth = _ref100.auth,
			    product = _ref100.product,
			    deviceId = _ref100.deviceId,
			    config = _ref100.config,
			    headers = _ref100.headers,
			    context = _ref100.context;

			return this.put({
				uri: '/v1/products/' + product + '/config/' + deviceId,
				data: config,
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Query location for devices within a product
   * @param  {Object} options            Options for this API call
   * @param  {String} options.product    Locations for this product ID or slug
   * @param  {String} options.auth       Access Token
   * @param  {String} options.dateRange  Start and end date in ISO8601 format, separated by comma, to query
   * @param  {String} options.rectBl     Bottom left of the rectangular bounding box to query. Latitude and longitude separated by comma
   * @param  {String} options.rectTr     Top right of the rectangular bounding box to query. Latitude and longitude separated by comma
   * @param  {String} options.deviceId   Device ID prefix to include in the query
   * @param  {String} options.deviceName Device name prefix to include in the query
   * @param  {String} options.groups     Array of group names to include in the query
   * @param  {String} options.page       Page of results to display. Defaults to 1
   * @param  {String} options.perPage    Number of results per page. Defaults to 20. Maximum of 100
   * @param {Object} [options.headers]   Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]   Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductLocations',
		value: function getProductLocations(_ref101) {
			var auth = _ref101.auth,
			    product = _ref101.product,
			    dateRange = _ref101.dateRange,
			    rectBl = _ref101.rectBl,
			    rectTr = _ref101.rectTr,
			    deviceId = _ref101.deviceId,
			    deviceName = _ref101.deviceName,
			    groups = _ref101.groups,
			    page = _ref101.page,
			    perPage = _ref101.perPage,
			    headers = _ref101.headers,
			    context = _ref101.context;

			return this.get({
				uri: '/v1/products/' + product + '/locations',
				query: {
					date_range: dateRange,
					rect_bl: rectBl,
					rect_tr: rectTr,
					device_id: deviceId,
					device_name: deviceName,
					groups: groups,
					page: page,
					per_page: perPage
				},
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Query location for one device within a product
   * @param  {Object} options           Options for this API call
   * @param  {String} options.product   Locations for this product ID or slug
   * @param  {String} options.auth      Access Token
   * @param  {String} options.dateRange Start and end date in ISO8601 format, separated by comma, to query
   * @param  {String} options.rectBl    Bottom left of the rectangular bounding box to query. Latitude and longitude separated by comma
   * @param  {String} options.rectTr    Top right of the rectangular bounding box to query. Latitude and longitude separated by comma
   * @param  {String} options.deviceId  Device ID to query
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @param {Object} [options.headers]  Key/Value pairs like `{ 'X-FOO': 'foo', X-BAR: 'bar' }` to send as headers.
   * @param {Object} [options.context]  Request context
   * @returns {Promise} A promise
   */

	}, {
		key: 'getProductDeviceLocations',
		value: function getProductDeviceLocations(_ref102) {
			var auth = _ref102.auth,
			    product = _ref102.product,
			    dateRange = _ref102.dateRange,
			    rectBl = _ref102.rectBl,
			    rectTr = _ref102.rectTr,
			    deviceId = _ref102.deviceId,
			    headers = _ref102.headers,
			    context = _ref102.context;

			return this.get({
				uri: '/v1/products/' + product + '/locations/' + deviceId,
				query: {
					date_range: dateRange,
					rect_bl: rectBl,
					rect_tr: rectTr
				},
				auth: auth,
				headers: headers,
				context: context
			});
		}

		/**
   * Set default auth token that will be used in each method if `auth` is not provided
   * @param  {String} auth A Particle access token
   * @returns {undefined}
   */

	}, {
		key: 'setDefaultAuth',
		value: function setDefaultAuth(auth) {
			if (typeof auth === 'string' && auth.length !== 0) {
				this._defaultAuth = auth;
			} else {
				throw new Error('Must pass a non-empty string');
			}
		}
		/**
   * Return provided token if truthy else use default auth if truthy else undefined
   * @param {*} auth Optional auth token or undefined
   * @private
   * @returns {String|undefined} a Particle auth token or undefined
   */

	}, {
		key: '_getActiveAuthToken',
		value: function _getActiveAuthToken(auth) {
			return auth || this._defaultAuth;
		}
		/**
   * API URI to access a device
   * @param  {Object} options Options for this API call
   * @param  {String} options.deviceId  Device ID to access
   * @param  {String} [options.product] Device only in this product ID or slug
   * @private
   * @returns {string} URI
   */

	}, {
		key: 'deviceUri',
		value: function deviceUri(_ref103) {
			var deviceId = _ref103.deviceId,
			    product = _ref103.product;

			return product ? '/v1/products/' + product + '/devices/' + deviceId : '/v1/devices/' + deviceId;
		}
	}, {
		key: 'get',
		value: function get(_ref104) {
			var uri = _ref104.uri,
			    auth = _ref104.auth,
			    headers = _ref104.headers,
			    query = _ref104.query,
			    context = _ref104.context;

			context = this._buildContext(context);
			auth = this._getActiveAuthToken(auth);
			return this.agent.get({ uri: uri, auth: auth, headers: headers, query: query, context: context });
		}
	}, {
		key: 'head',
		value: function head(_ref105) {
			var uri = _ref105.uri,
			    auth = _ref105.auth,
			    headers = _ref105.headers,
			    query = _ref105.query,
			    context = _ref105.context;

			context = this._buildContext(context);
			auth = this._getActiveAuthToken(auth);
			return this.agent.head({ uri: uri, auth: auth, headers: headers, query: query, context: context });
		}
	}, {
		key: 'post',
		value: function post(_ref106) {
			var uri = _ref106.uri,
			    auth = _ref106.auth,
			    headers = _ref106.headers,
			    data = _ref106.data,
			    context = _ref106.context;

			context = this._buildContext(context);
			auth = this._getActiveAuthToken(auth);
			return this.agent.post({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}
	}, {
		key: 'put',
		value: function put(_ref107) {
			var uri = _ref107.uri,
			    auth = _ref107.auth,
			    headers = _ref107.headers,
			    data = _ref107.data,
			    context = _ref107.context;

			context = this._buildContext(context);
			auth = this._getActiveAuthToken(auth);
			return this.agent.put({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}
	}, {
		key: 'delete',
		value: function _delete(_ref108) {
			var uri = _ref108.uri,
			    auth = _ref108.auth,
			    headers = _ref108.headers,
			    data = _ref108.data,
			    context = _ref108.context;

			context = this._buildContext(context);
			auth = this._getActiveAuthToken(auth);
			return this.agent.delete({ uri: uri, auth: auth, headers: headers, data: data, context: context });
		}
	}, {
		key: 'request',
		value: function request(args) {
			args.context = this._buildContext(args.context);
			args.auth = this._getActiveAuthToken(args.auth);
			return this.agent.request(args);
		}
	}, {
		key: 'client',
		value: function client() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			return new _Client2.default((0, _assign2.default)({ api: this }, options));
		}

		// Internal method used to target Particle's APIs other than the default

	}, {
		key: 'setBaseUrl',
		value: function setBaseUrl(baseUrl) {
			this.baseUrl = baseUrl;
			this.agent.setBaseUrl(baseUrl);
		}
	}]);
	return Particle;
}();

// Aliases for backwards compatibility


Particle.prototype.removeAccessToken = Particle.prototype.deleteAccessToken;

exports.default = Particle;
module.exports = exports['default'];
//# sourceMappingURL=Particle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/particle-api-js/lib/Particle.js
 ** module id = 183
 ** module chunks = 0
 **/